import {
  IconAnalytics,
  IconAtom,
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconChartRadiusGray,
  IconClockGray,
  IconCloudCheckGray,
  IconCoil,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconPenSquare,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconTagGray,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconWarningGray,
  IconZoneGray,
} from '@assets/images/icon';
import { IconTemp } from '@assets/images/main';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/manufacturingProcess/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/manufacturingAsset/img/1.avif';
import image2 from '@src/assets/images/solution/manufacturingAsset/img/2.avif';
import image3 from '@src/assets/images/solution/manufacturingAsset/img/3.avif';
import image4 from '@src/assets/images/solution/manufacturingAsset/img/4.avif';
import image5 from '@src/assets/images/solution/manufacturingAsset/img/5.avif';
import image6 from '@src/assets/images/solution/manufacturingAsset/img/6.avif';
import image7 from '@src/assets/images/solution/manufacturingAsset/img/7.avif';
import image8 from '@src/assets/images/solution/manufacturingAsset/img/8.avif';

export default {
  type: 'Giải pháp sản xuất',
  banner: {
    title: 'Quản lý tài sản tồn kho trong kho logistics lớn bằng AI một cách hiệu quả và chính xác',
    desc: 'Ứng dụng công nghệ nhận diện video AI để tự động nhận diện cuộn thép và nhiều loại tài sản logistics khác, giúp quản lý tồn kho chính xác và hiệu quả.',
  },

  video: {
    title: 'Quản lý tài sản tồn kho theo thời gian thực bằng AI ngay cả trong môi trường logistics phức tạp.',
    desc: 'Phương pháp đếm thủ công truyền thống không hiệu quả và dễ sai sót trong môi trường logistics phức tạp. Hệ thống AI của ORBRO tự động nhận diện và quản lý các tài sản như cuộn thép, nâng cao hiệu quả vận hành kho.',
    // play: video,
    image: image1,
  },

  func: [
    {
      theme: 'Quản lý chính xác các loại tài sản logistics bằng công nghệ phân tích video AI.',
      title: 'Đếm tài sản tự động dựa trên video AI',
      desc: 'Camera AI nhận diện và đếm tự động các tài sản logistics như cuộn thép theo thời gian thực với độ chính xác cao. Dễ dàng quản lý tồn kho nhanh chóng và chính xác ngay cả trong kho phức tạp.',
      sub1: 'Giám sát tình trạng theo thời gian thực',
      icon1: IconClockGray,
      sub2: 'Cung cấp dữ liệu thống kê',
      icon2: IconChartBarGray,
      image: image2,
    },
    {
      title: 'Nhận diện & quản lý cuộn thép và pallet bằng AI',
      desc: 'Nhận diện đồng thời cuộn thép và pallet bằng công nghệ video AI, quản lý tài sản hỗn hợp một cách hiệu quả. Dù nhiều loại hình dạng tài sản cùng tồn tại, vẫn quản lý tồn kho dễ dàng.',
      sub1: 'Theo dõi vị trí theo thời gian thực',
      icon1: IconBinocularsGray,
      sub2: 'Độ chính xác cao',
      icon2: IconRulerGray,
      image: image3,
    },
    {
      title: 'Học và quản lý tự động nhiều mô hình tài sản',
      desc: 'AI học và nhận diện nhiều loại tài sản bao gồm cuộn thép và pallet, giúp quản lý tài sản phức tạp một cách chính xác.',
      sub1: 'Chỉ định tài sản rủi ro',
      icon1: IconWarningGray,
      sub2: 'Thiết lập phương án xử lý',
      icon2: IconChartRadiusGray,
      image: image4,
    },
    {
      theme: 'Tối đa hóa hiệu quả vận hành logistics bằng phân tích dữ liệu tự động.',
      title: 'Nắm bắt tồn kho theo khu vực theo thời gian thực',
      desc: 'Kiểm tra ngay tình trạng tồn kho của từng khu vực trong kho, vận hành chính xác dựa trên dữ liệu và hỗ trợ ra quyết định nhanh chóng.',
      sub1: 'Lưu dữ liệu trên cloud',
      icon1: IconClockGray,
      sub2: 'Cung cấp dữ liệu thống kê',
      icon2: IconChartBarGray,
      image: image5,
    },
    {
      title: 'Theo dõi & dự đoán biến động tồn kho theo khung giờ',
      desc: 'Tự động ghi nhận và phân tích sự thay đổi lượng tồn kho theo từng khung giờ, dự đoán dòng chảy logistics chính xác và xử lý hiệu quả.',
      sub1: 'Chỉ định tài sản rủi ro',
      icon1: IconWarningGray,
      sub2: 'Thiết lập phương án xử lý',
      icon2: IconChartRadiusGray,
      image: image6,
    },
    {
      title: 'Tự động hóa quản lý tồn kho thủ công',
      desc: 'Tự động đếm bằng AI giúp loại bỏ sai sót và tốn thời gian từ phương pháp quản lý thủ công truyền thống.',
      sub1: 'Lưu dữ liệu trên cloud',
      icon1: IconClockGray,
      sub2: 'Cung cấp dữ liệu thống kê',
      icon2: IconChartBarGray,
      image: image7,
    },
    {
      title: 'Xuất dữ liệu phân tích dưới dạng CSV',
      desc: 'Xuất dễ dàng dữ liệu tồn kho và logistics đã phân tích dưới dạng file CSV để phục vụ báo cáo và phân tích chi tiết.',
      sub1: 'Lưu dữ liệu trên cloud',
      icon1: IconClockGray,
      sub2: 'Cung cấp dữ liệu thống kê',
      icon2: IconChartBarGray,
      image: image8,
    },
  ],

  system: {
    title: 'Cấu trúc hệ thống',
    img: rtlsSystem,
  },

  productTitle: 'Gói sản phẩm',
  product: [
    {
      tag: 'assetPackage',
    },
    {
      tag: 'workerPackage',
    },
  ],

  subfunc: {
    title: 'Tóm tắt tính năng chính',
    desc: '',

    data: [
      {
        icon: IconAtom,
        title: 'Nhận diện tài sản tự động bằng AI',
        desc: 'Nhận diện tài sản tự động theo thời gian thực bằng công nghệ AI, quản lý chính xác và hiệu quả.',
      },
      {
        icon: IconCoil,
        title: 'Nhận diện cuộn thép và pallet',
        desc: 'AI nhận diện đồng thời cuộn thép và pallet, quản lý tồn kho chính xác ngay cả trong môi trường phức tạp.',
      },
      {
        icon: IconLocation,
        title: 'Giám sát vị trí & trạng thái tài sản',
        desc: 'Phân tích vị trí và trạng thái tài sản trong kho theo thời gian thực, quản lý hiệu quả.',
      },
      {
        icon: IconPenSquare,
        title: 'Tự động hóa quản lý tồn kho thủ công',
        desc: 'Tự động hóa công việc quản lý tồn kho thủ công, nâng cao hiệu suất và độ chính xác.',
      },
      {
        icon: IconDashboard,
        title: 'Bảng điều khiển trạng thái tồn kho theo thời gian thực',
        desc: 'Cung cấp bảng điều khiển trực quan để dễ dàng nắm bắt trạng thái tài sản trong kho.',
      },
      {
        icon: IconRoute,
        title: 'Phân tích lộ trình di chuyển tài sản',
        desc: 'AI phân tích lộ trình di chuyển và mô hình sử dụng của tài sản, hỗ trợ lập kế hoạch vận hành hiệu quả.',
      },
      {
        icon: IconLayers,
        title: 'Quản lý tồn kho theo khu vực theo thời gian thực',
        desc: 'Kiểm tra trạng thái tài sản của từng khu vực theo thời gian thực, quản lý chính xác và hiệu quả.',
      },
      {
        icon: IconChartBar,
        title: 'Phân tích biến động tồn kho theo khung giờ',
        desc: 'Phân tích biến động tồn kho theo khung giờ, dự đoán dòng chảy logistics và xử lý nhanh.',
      },
      {
        icon: IconSecurity,
        title: 'Độ chính xác nhận diện AI cao',
        desc: 'AI nhận diện nhiều loại tài sản với độ chính xác trên 99%, cung cấp dữ liệu đáng tin cậy.',
      },
      {
        icon: IconAnalytics,
        title: 'Hỗ trợ ra quyết định dựa trên dữ liệu vận hành',
        desc: 'Dựa trên dữ liệu vận hành đã phân tích, hỗ trợ đưa ra quyết định và chiến lược nhanh chóng, chính xác.',
      },
    ],
  },

  contents: [
    {
      data: 'manufacturingAsset',
    },
    {
      data: 'logisticsAsset',
    },
    {
      data: 'blogMedical',
    },
    {
      data: 'blogRTLS',
    },
  ],
};
